import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateDimmed,
  updateSignupVisible,
} from "../../../../features/forms/formsSlice";
import {
  SignupFormWrapper,
  InputWrapper,
  Username,
  Password,
  Caption,
  UpdateMessage,
  ButtonsWrapper,
  SignUp,
  Cancel,
} from "./SignupFormStyles";
import {
  registerUser,
  clearAuthError,
  // ❌ DO NOT CLEAR signup success on close anymore
  // clearSignupSuccess,
} from "../../../../features/auth/authSlice";

const SignupForm = ({ signupVisible }) => {
  const [usernameValue, setUsernameValue] = useState(""); // email as username
  const [passwordValue, setPasswordValue] = useState("");
  const [confirmValue, setConfirmValue] = useState("");
  const [updateMessage, setUpdateMessage] = useState("");

  const dispatch = useDispatch();
  const { loading, error, lastSignupSuccess } = useSelector(
    (state) => state.auth
  );

  const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

  const resetLocalState = () => {
    setUsernameValue("");
    setPasswordValue("");
    setConfirmValue("");
    setUpdateMessage("");
  };

  const closeForm = () => {
    resetLocalState();
    dispatch(clearAuthError());
    // ❌ do NOT clear signup success here
    // dispatch(clearSignupSuccess());
    dispatch(updateSignupVisible(false));
    dispatch(updateDimmed(false));
  };

  const clickSignup = (e) => {
    e.preventDefault();

    // username is email
    if (!usernameValue) {
      setUpdateMessage("Please enter your email address.");
      return;
    }

if (!passwordRegex.test(passwordValue)) {
  setUpdateMessage(
    "Password must be at least 8 characters and include one capital letter and one number."
  );
  return;
}

    if (passwordValue !== confirmValue) {
      setUpdateMessage("Passwords do not match.");
      return;
    }

    // trigger API call – username and email are the same
    dispatch(
      registerUser({
        username: usernameValue,
        email: usernameValue,
        password: passwordValue,
      })
    );
  };

  const clickClose = (e) => {
    e.preventDefault();
    closeForm();
  };

  // Drive UpdateMessage from Redux auth state
  useEffect(() => {
    if (!signupVisible) {
      // When form is hidden, just clear local text/fields
      resetLocalState();
      dispatch(clearAuthError());
      // ❌ keep lastSignupSuccess, so User can still show "now registered"
      // dispatch(clearSignupSuccess());
      return;
    }

    if (loading) {
      setUpdateMessage("Creating your account...");
      return;
    }

    if (error) {
      // e.g. "Email already exists" from backend
      setUpdateMessage(error);
      return;
    }

    if (lastSignupSuccess) {
      setUpdateMessage("Account created! You can now log in.");
      return;
    }

    // default
    if (!loading && !error && !lastSignupSuccess) {
      setUpdateMessage("");
    }
  }, [signupVisible, loading, error, lastSignupSuccess, dispatch]);

  return (
    <SignupFormWrapper signupVisible={signupVisible}>
      <InputWrapper>
        <Caption>Email (this will be your username):</Caption>
        <Username
          type="email"
          value={usernameValue}
          onChange={(e) => setUsernameValue(e.target.value)}
        />
      </InputWrapper>
      <InputWrapper>
        <Caption>Password:</Caption>
        <Password
          type="password"
          value={passwordValue}
          onChange={(e) => setPasswordValue(e.target.value)}
        />
      </InputWrapper>
      <InputWrapper>
        <Caption>Confirm password:</Caption>
        <Password
          type="password"
          value={confirmValue}
          onChange={(e) => setConfirmValue(e.target.value)}
        />
      </InputWrapper>

      {/* All update & error messages live here */}
      <UpdateMessage>{updateMessage}</UpdateMessage>

      <ButtonsWrapper>
        {/* After success, this becomes "Close" */}
        <SignUp
          onClick={lastSignupSuccess ? clickClose : clickSignup}
          disabled={loading}
        >
          {lastSignupSuccess ? "Close" : "Sign up"}
        </SignUp>
        <Cancel onClick={clickClose}>Cancel</Cancel>
      </ButtonsWrapper>
    </SignupFormWrapper>
  );
};

export default SignupForm;
